import React from 'react';
import { Header } from 'src/design/organisms/Header';
import { UserForm } from 'src/routes/Settings/Users/components/UserForm';

export const CreateUser: React.FC = () => {
  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Settings', href: '/settings' },
            { text: 'Users', href: '/settings/users' },
            { text: 'Add User' },
          ],
        }}
        title="Add User"
        helpText="Users can login to the system and access the divisions and jobs they are assigned to."
      />
      <UserForm />
    </>
  );
};
